<template>
	<!-- 质检扫码：仅将扫码结果交给巡检任务扫码接口。 -->
	<span>
		<AButton style="width: 70px; height: 40px;" size="large" type="primary" @click="scanCode">扫码</AButton>
		<XModal ref="modal" title="扫码巡检任务" :destroyOnClose="true" :ok="ok" :cancel-btn="false" :width="420">
			<div v-if="tasks.length" class="task-list">
				<button v-for="(task, index) in tasks" :key="task.id" type="button" class="task-item"
					:class="{ active: selectedIndex === index }" @click="selectTask(index)">
					<span class="task-check">✓</span>
					<span class="task-info">
						<strong>{{ task.code }}</strong>
						<span>{{ task.processName || '未设置工序' }}</span>
						<span>{{ task.orderCode || '未关联生产订单' }}</span>
					</span>
					<span class="task-status" :class="taskStatus(task).badgeClass">{{ taskStatus(task).name || '待检验'
						}}</span>
				</button>
			</div>
			<div v-else class="empty">未查询到巡检任务</div>
		</XModal>
	</span>
</template>

<script>
import { patrolTaskScan } from '@api'
import { mapMutations } from 'vuex'

export default {
	name: "ScanCodeDialog",
	data() {
		return {
			tasks: [],
			// 扫码结果列表的唯一选中下标，确认后才写入当前工单。
			selectedIndex: -1,
		};
	},
	mounted() {
		window.onScanCodeResult = this.onScanCodeResult;
		window.getScanDeCodeResult = this.onScanCodeResult;
	},
	methods: {
		...mapMutations(["setWorkOrder"]),
		// 弹窗确认后，将当前选中的巡检任务写入 Vuex。
		ok() {
			const task = this.tasks[this.selectedIndex];
			if (!task) {
				this.$message.warning("请先选择巡检任务。");
				return;
			}
			this.setWorkOrder(task);
			this.$message.success(`已选中巡检任务：${task.code || task.id}`);
			this.$refs.modal.cancel();
		},
		// 仅切换扫码列表高亮，等待点击确定后再加载任务详情。
		selectTask(index) {
			this.selectedIndex = index;
		},
		scanCode() {
			if (window.AndroidWebView) {
				window.AndroidWebView.scanCode();
				return;
			}

			const code = prompt("");
			if (code && code.trim()) {
				this.onScanCodeResult(code.trim());
			}
		},
		async onScanCodeResult(code) {
			if (!code) return;

			try {
				const response = await patrolTaskScan(code);
				console.log("patrolTaskScan", response);
				const data = response.data || response;
				this.tasks = Array.isArray(data) ? data : [];
				this.selectedIndex = -1;
				this.$refs.modal.open();
			} catch (error) {
				console.error("patrolTaskScan", error);
			}
		},
		taskStatus(task) {
			return task.status || {};
		},
	},
};
</script>

<style lang="less" scoped>
.task-list {
	display: grid;
	gap: 10px;
}

.task-item {
	display: grid;
	grid-template-columns: 36px minmax(0, 1fr) auto;
	gap: 10px;
	align-items: start;
	padding: 13px 12px;
	color: #192d45;
	text-align: left;
	cursor: pointer;
	background: #fff;
	border: 1px solid #d6e2ed;
	border-radius: 12px;
}

.task-item.active {
	background: #f2f8ff;
	border-color: #6fa6de;
}

.task-check {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	color: #5f89b5;
	font-size: 22px;
	background: #edf4fb;
	border-radius: 10px;
}

.task-info {
	display: grid;
	min-width: 0;
	gap: 2px;
}

.task-info strong,
.task-info span {
	overflow: hidden;
	font-size: 14px;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.task-info strong {
	color: #111;
}

.task-info span:last-child {
	color: #31465b;
}

.task-status {
	padding: 4px 8px;
	color: #9b5b17;
	font-size: 12px;
	white-space: nowrap;
	background: #fff3e2;
	border-radius: 7px;
}

.task-status.success {
	color: #167b4d;
	background: #e3f6ec;
}

.empty {
	padding: 30px 16px;
	color: #62758a;
	text-align: center;
	background: #f3f6fa;
	border: 1px dashed #bacbdb;
	border-radius: 8px;
}
</style>
